import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetProjectByIdQuery,
  usePublicGetProjectByIdQuery,
  useGetProjectResultsQuery,
  usePublicGetProjectResultsQuery,
  useGetProjectsQuery,
  usePublicGetProjectsQuery,
  useLazyGetProjectByIdQuery,
  useLazyPublicGetProjectByIdQuery,
  useUpdateProjectMutation,
  useCreateProjectMutation,
  useDeleteProjectMutation,
  useCreateProjectCopyMutation,
  useAddTagToProjectMutation,
  useDeleteTagFromProjectMutation,
  useDeleteMembershipMutation,
  useDeleteProjectAttachmentMutation,
  useFinalizeProjectMutation,
  useGetProjectAttachmentsQuery,
  useGetAllTagsQuery,
  useGetProjectMembershipsQuery,
  useGetProjectResultsByGasQuery,
  useGetSOCrefQuery,
  useGetTagsByProjectQuery,
  useLazyDownloadProjectAttachmentQuery,
  useLazyDownloadProjectReportQuery,
  useLazyGetMyMembershipsQuery,
  useLazyPublicDownloadProjectAttachmentQuery,
  useLazyPublicDownloadProjectReportQuery,
  useLazyPublicGetMyMembershipsQuery,
  useMoveToTrashbinMutation,
  usePublicGetAllTagsQuery,
  usePublicGetProjectAttachmentsQuery,
  usePublicGetProjectMembershipsQuery,
  usePublicGetProjectResultsByGasQuery,
  usePublicGetSOCrefQuery,
  usePublicGetTagsByProjectQuery,
  useTogglePublicProjectMutation,
  useUploadMapDataMutation,
  useUploadProjectAttachmentMutation,
  useGetProjectLockInfoQuery,
  usePublicGetProjectLockInfoQuery,
  useToggleProjectLockMutation,
} from '../features/project/projectApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting a project by ID based on the current route.
 */
export const useContextAwareGetProjectById = createContextAwareHook(
  useGetProjectByIdQuery,
  usePublicGetProjectByIdQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for lazy loading a project by ID based on the current route.
 */
export const useContextAwareLazyGetProjectById = createContextAwareHook(
  useLazyGetProjectByIdQuery,
  useLazyPublicGetProjectByIdQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting project results based on the current route.
 */
export const useContextAwareGetProjectResults = createContextAwareHook(
  useGetProjectResultsQuery,
  usePublicGetProjectResultsQuery
);

export const useContextAwareGetProjectResultsByGas = createContextAwareHook(
  useGetProjectResultsByGasQuery,
  usePublicGetProjectResultsByGasQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting a list of projects based on the current route.
 */
export const useContextAwareGetProjects = createContextAwareHook(
  useGetProjectsQuery,
  usePublicGetProjectsQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting all tags based on the current route.
 */
export const useContextAwareGetAllTags = createContextAwareHook(
  useGetAllTagsQuery,
  usePublicGetAllTagsQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting tags by project based on the current route.
 */
export const useContextAwareGetTagsByProject = createContextAwareHook(
  useGetTagsByProjectQuery,
  usePublicGetTagsByProjectQuery
);

export const useContextAwareDownloadProjectReport = createContextAwareHook(
  useLazyDownloadProjectReportQuery,
  useLazyPublicDownloadProjectReportQuery
);

export const useContextAwareGetProjectLockInfo = createContextAwareHook(
  useGetProjectLockInfoQuery,
  usePublicGetProjectLockInfoQuery
);

export {
  useUpdateProjectMutation,
  useCreateProjectMutation,
  useDeleteProjectMutation,
  useCreateProjectCopyMutation,
  useAddTagToProjectMutation,
  useDeleteTagFromProjectMutation,
  useDeleteMembershipMutation,
  useDeleteProjectAttachmentMutation,
  useFinalizeProjectMutation,
  useGetProjectAttachmentsQuery,
  useGetAllTagsQuery,
  useGetProjectMembershipsQuery,
  useGetProjectResultsByGasQuery,
  useGetSOCrefQuery,
  useGetTagsByProjectQuery,
  useLazyDownloadProjectAttachmentQuery,
  useLazyDownloadProjectReportQuery,
  useLazyGetMyMembershipsQuery,
  useLazyPublicDownloadProjectAttachmentQuery,
  useLazyPublicDownloadProjectReportQuery,
  useLazyPublicGetMyMembershipsQuery,
  useMoveToTrashbinMutation,
  usePublicGetAllTagsQuery,
  usePublicGetProjectAttachmentsQuery,
  usePublicGetProjectMembershipsQuery,
  usePublicGetProjectResultsByGasQuery,
  usePublicGetSOCrefQuery,
  usePublicGetTagsByProjectQuery,
  useTogglePublicProjectMutation,
  useUploadMapDataMutation,
  useUploadProjectAttachmentMutation,
  useToggleProjectLockMutation,
}